import React, {useMemo} from "react";
import {Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import useStatisticsData from "../Statistics/useStatisticsData.js";
import {formatNumber, formatPercent, GROUP_PALETTE, monochromeScale} from "../Statistics/format.js";
import {bereichLabel} from "./format.js";
import NutzungWidget from "./NutzungWidget.jsx";

/**
 * Bereichsverteilung - waagerechte Balken, absteigend nach Ereignissen
 * (gleicher Aufbau wie TopArticlesChart aus der Verkaufsstatistik). Der
 * "anteil" aus der Antwort wird - wie return_rate bei den Verkaufs-
 * Kennzahlen - als Anteil zwischen 0 und 1 angenommen.
 */
export default function NutzungBereichsverteilung({filters}) {
    const {data, loading, error} = useStatisticsData("/nutzung/daten/bereiche", filters);
    const rows = useMemo(() => {
        const liste = Array.isArray(data) ? data : [];
        return [...liste].sort((a, b) => (b.ereignisse || 0) - (a.ereignisse || 0));
    }, [data]);

    const farben = useMemo(() => monochromeScale(GROUP_PALETTE[0], rows.length || 1), [rows.length]);
    const height = Math.max(220, rows.length * 34);

    return (
        <NutzungWidget
            title="Bereichsverteilung"
            help="Ereignisse je Bereich im gewählten Zeitraum und Filter."
            loading={loading}
            error={error}
            empty={!loading && !error && rows.length === 0}
            height={height}
        >
            <ResponsiveContainer width="100%" height={height}>
                <BarChart data={rows} layout="vertical" margin={{top: 4, right: 24, left: 8, bottom: 4}}>
                    <XAxis type="number" tickFormatter={formatNumber} tick={{fontSize: 12}} axisLine={false} tickLine={false} />
                    <YAxis type="category" dataKey="bereich" tickFormatter={bereichLabel} width={130} tick={{fontSize: 12}} axisLine={false} tickLine={false} />
                    <Tooltip
                        formatter={(value, name, item) => [
                            `${formatNumber(value)} (${formatPercent((item?.payload?.anteil || 0) * 100)}, ${formatNumber(item?.payload?.nutzer || 0)} Mitarbeiter)`,
                            "Ereignisse",
                        ]}
                        labelFormatter={(label) => bereichLabel(label)}
                    />
                    <Bar dataKey="ereignisse" radius={[0, 6, 6, 0]} barSize={18}>
                        {rows.map((row, index) => (
                            <Cell key={row.bereich} fill={farben[index]} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </NutzungWidget>
    );
}
